import { useSearchTableScope } from '@aibees/elephant/context/search-table-scope';
import { useSearchParamsStore } from '@aibees/elephant/store/search-params-store';
import { classnames } from '@aibees/shared/utils';
import { memo, useCallback } from 'react';
import { useEntitySearchData } from '../entity-search-header/hooks/use-entity-search-data';
import { formatNumber } from '../search-bar/utils';
import { StatisticsCard } from '../statistics-card';
import * as Styled from './styles';
import * as SX from './sx';
import type { StatisticsCardWrapperProps as Props } from './types';

export const StatisticsCardWrapper = memo(({ className }: Props) => {
  const scope = useSearchTableScope();
  const setParamForScope = useSearchParamsStore.useSetParamForScope();
  const {
    isFetching,
    totalRecordsValue,
    netNewRecordsValue,
    savedRecordsValue,
  } = useEntitySearchData();

  const handleSavedRecordsViewClick = useCallback(() => {
    if (scope == null) return;
    setParamForScope(scope, 'modality', 'SAVED');
  }, [scope, setParamForScope]);

  return (
    <Styled.Wrapper
      className={classnames('StatisticsCardWrapper', className)}
      sx={SX.root}
    >
      <StatisticsCard
        title="Total Records"
        icon="grain"
        value={formatNumber(totalRecordsValue)}
        isFetching={isFetching}
      />
      <StatisticsCard
        title="Net New Records"
        icon="equalizer"
        value={formatNumber(netNewRecordsValue)}
        isFetching={isFetching}
      />
      <StatisticsCard
        title="Saved Records"
        icon="grid"
        iconValue="chevron-right"
        value={formatNumber(savedRecordsValue)}
        onViewClick={
          savedRecordsValue ? handleSavedRecordsViewClick : undefined
        }
        isFetching={isFetching}
      />
    </Styled.Wrapper>
  );
});

StatisticsCardWrapper.displayName = 'StatisticsCardWrapper';
